import {Translation} from "react-i18next";

export const columns = [
    {
        title: (
            <Translation>
                {(t, { i18n }) => <span>{t("formulaTitle.columnKeyword")}</span>}
            </Translation>
        ),
        dataIndex: "column",
        width: 245,
    },
    {
        title: (
            <Translation>
                {(t, { i18n }) => <span>{t("formulaTitle.name")}</span>}
            </Translation>
        ),
        dataIndex: "name",
        width: 316,
    },
    {
        title: (
            <Translation>
                {(t, { i18n }) => <span>{t("formulaTitle.default")}</span>}
            </Translation>
        ),
        dataIndex: "defaultValue",
        width: 350,
    },
    {
        title: (
            <Translation>
                {(t, { i18n }) => <span>{t("formulaTitle.example")}</span>}
            </Translation>
        ),
        dataIndex: "example",
        width: 100,
    },
    {
        title: (
            <Translation>
                {(t, { i18n }) => <span>{t("formulaTitle.noteKeyword")}</span>}
            </Translation>
        ),
        dataIndex: "note",
        width: 350
    }
];